import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconUnfoldMoreComponent } from "./med-icon-unfold-more.component";

@NgModule({
  declarations: [
    MedIconUnfoldMoreComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconUnfoldMoreComponent,
  ],
})
export class MedIconUnfoldMoreModule { }
